// 静态菜单树定义（政企PK答题管理端）
// authType: '0' 目录 / '1' 菜单
const STATIC_MENU_TREE = [
  {
    authId: 10,
    authName: '题库管理',
    authIcon: 'el-icon-reading',
    authType: '0',
    children: [
      { authId: 11, authName: '题目分类', authUrl: '/question-topic-class/list', authIcon: 'el-icon-collection-tag', authType: '1', children: [] },
      { authId: 12, authName: '试题类型', authUrl: '/question-topic-type/list', authIcon: 'el-icon-files', authType: '1', children: [] },
      { authId: 13, authName: '试题管理', authUrl: '/question-topic/list', authIcon: 'el-icon-edit-outline', authType: '1', children: [] }
    ]
  },
  {
    authId: 20,
    authName: '考试管理',
    authIcon: 'el-icon-edit',
    authType: '0',
    children: [
      { authId: 21, authName: '试卷管理', authUrl: '/question-paper/list', authIcon: 'el-icon-document', authType: '1', children: [] },
      { authId: 22, authName: '答题结果', authUrl: '/question-paper-record/list', authIcon: 'el-icon-data-line', authType: '1', children: [] }
    ]
  },
  {
    authId: 30,
    authName: 'PK对战',
    authIcon: 'el-icon-trophy',
    authType: '0',
    children: [
      { authId: 31, authName: 'PK试卷', authUrl: '/pkq-paper/list', authIcon: 'el-icon-aim', authType: '1', children: [] },
      { authId: 32, authName: 'PK规则', authUrl: '/pkq-rule/list', authIcon: 'el-icon-set-up', authType: '1', children: [] },
      { authId: 33, authName: '用户统计', authUrl: '/pkq-user-statistics/list', authIcon: 'el-icon-data-analysis', authType: '1', children: [] },
      { authId: 34, authName: '错题记录', authUrl: '/pkq-user-wrong/list', authIcon: 'el-icon-warning', authType: '1', children: [] }
    ]
  },
  {
    authId: 40,
    authName: '系统管理',
    authIcon: 'el-icon-setting',
    authType: '0',
    children: [
      { authId: 41, authName: '用户管理', authUrl: '/auth-user/list', authIcon: 'el-icon-user', authType: '1', children: [] },
      { authId: 42, authName: '项目管理', authUrl: '/auth-project/list', authIcon: 'el-icon-office-building', authType: '1', children: [] },
      { authId: 43, authName: '部门管理', authUrl: '/auth-department/list', authIcon: 'el-icon-share', authType: '1', children: [] }
    ]
  }
]

// 系统管理目录 authId（项目管理员可见，普通用户隐藏）
const SYSTEM_DIR_ID = 40
// 项目管理菜单 authId（仅系统管理员可见，项目管理员隐藏 —— 即不能创建/管理项目）
const PROJECT_MANAGE_ID = 42

// 按岗位过滤菜单：
// - 系统管理员(zauPost=1)：全部可见
// - 项目管理员(zauPost=2)：隐藏"项目管理"菜单，保留用户管理/部门管理
// - 普通用户(zauPost=3)：隐藏整个"系统管理"目录
function filterMenuByUser (zauPost) {
  const isAdmin = zauPost === 1
  const isProjAdmin = zauPost === 2
  if (isAdmin) return STATIC_MENU_TREE
  return STATIC_MENU_TREE
    .filter(item => {
      // 系统管理目录：项目管理员保留，普通用户隐藏
      if (item.authId === SYSTEM_DIR_ID) return isProjAdmin
      return true
    })
    .map(item => {
      if (item.children && item.children.length) {
        return {
          ...item,
          children: item.children.filter(child => child.authId !== PROJECT_MANAGE_ID)
        }
      }
      return item
    })
}

const state = {
  menuTree: STATIC_MENU_TREE,
  routesGenerated: true
}

const mutations = {
  SET_MENU_TREE (state, tree) {
    state.menuTree = tree || STATIC_MENU_TREE
  }
}

const actions = {
  // 根据用户岗位生成可见菜单
  generateMenu ({ commit }, userInfo) {
    const zauPost = userInfo && userInfo.zauPost
    const tree = zauPost !== undefined ? filterMenuByUser(zauPost) : STATIC_MENU_TREE
    commit('SET_MENU_TREE', tree)
  },
  resetPermission ({ commit }) {
    commit('SET_MENU_TREE', STATIC_MENU_TREE)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
